import { Component, OnInit } from '@angular/core';
import { GlobalInfoService } from '@app/core';
import { Boletines } from '@app/shared';
import { PublicatiosBulletinsDataService } from './shared/publicatios-bulletins.data.service';


@Component({
  selector: 'iw-publications-bulletin-management',
  templateUrl: './publications-bulletin-management.component.html',
  styleUrls: ['./publications-bulletin-management.component.scss'],
  providers: [PublicatiosBulletinsDataService]
})
export class PublicationsBulletinManagementComponent implements OnInit {
  bulletins: Boletines[] = [];
  constructor(
    private pbmds: PublicatiosBulletinsDataService,
    private gis: GlobalInfoService
  ) { }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Administración de publicaciones y boletines' });
    this.loadBulletins();
  }
  loadBulletins() {
    this.pbmds.getBulletins().subscribe(resp => {
      resp.forEach(e => {
        const b = new Boletines;
        switch (e.mes) {
          case 1:
            e.mes_letras = 'Enero';
            break;
          case 2:
            e.mes_letras = 'Febrero';
            break;
          case 3:
            e.mes_letras = 'Marzo';
            break;
          case 4:
            e.mes_letras = 'Abril';
            break;
          case 5:
            e.mes_letras = 'Mayo';
            break;
          case 6:
            e.mes_letras = 'Junio';
            break;
          case 7:
            e.mes_letras = 'Julio';
            break;
          case 8:
            e.mes_letras = 'Agosto';
            break;
          case 9:
            e.mes_letras = 'Septiembre';
            break;
          case 10:
            e.mes_letras = 'Octubre';
            break;
          case 11:
            e.mes_letras = 'Noviembre';
            break;
          case 12:
            e.mes_letras = 'Diciembre';
            break;
        }
        e.mostrar = `${e.codigo} - ${e.mes_letras} - ${e.ano}`;
      });
      this.bulletins = resp;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/publications-bulletin-management.component.ts